<template>
  <div>
    <video controls style="max-width: 100%; max-height: 500px; object-fit: cover;" v-if="video_source">
      <source :src="video_source" type="video/mp4"/>
    </video>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: {
    image_source: {
      type: String,
      required: false
    },
    video_source: {
      type: String,
      required: true
    }
  }
};
</script>

<style>
</style>